import * as Yup from 'yup';

const useUploadContactListValidationSchema = (shouldValidateIdentity: boolean) => {
  const validFileExtensions = ['.txt', '.csv', '.zip'];
  const isValidFileType = (fileName?: string) => {
    if (!fileName) return false;
    const ext = fileName.split('.').pop();
    if (!ext) return false;
    return validFileExtensions.indexOf(`.${ext}`) > -1;
  };

  const UploadContactListValidationSchema = Yup.object().shape({
    listType: Yup.string().required('Please select a list type'),
    listName: Yup.string().required('Please enter the list name'),
    file: Yup.mixed()
      .test(
        'is-valid-type',
        `Please enter a valid file type (${validFileExtensions.join(', ')})`,
        (value) => isValidFileType((value as File)?.name?.toLowerCase())
      )
      .required('Please enter a valid file'),
    identity_id: Yup.string().when([], (_, schema) => {
      if (shouldValidateIdentity) {
        return schema.required('Please select an identity to proceed');
      }
      return schema.optional();
    }),
  });
  return {
    UploadContactListValidationSchema,
    validFileExtensions,
  };
};

export default useUploadContactListValidationSchema;
